module.exports = function (S) {
  const getNextId = S.getNextId;
  const addSvgElementFromJson = S.addSvgElementFromJson;
  const canvas = S.canvas;
  const curConfig = S.curConfig;

  const snapDistance = 3;
  let objectsGuidelines;

  let lastDx = 0; let lastDy = 0;

  // Default enable for web, disabled for mobile
  let isEnabled = true;//! INKIVE.C.IS_MOBILE;

  var objectCoordinatesHelper = {
    getXCoordinates: function (coord) {
      return objectCoordinatesHelper.keyMatchingFilter(coord, /x\d+/);
    },
    getYCoordinates: function (coord) {
      return objectCoordinatesHelper.keyMatchingFilter(coord, /y\d+/);
    },
    keyMatchingFilter: function (coord, exp) {
      return _.filter(coord, function (value, key) { return key.match(exp); });
    }
  };

  let objectCoord = {};

  function initObjectCoordInfo () {
    objectCoord = [];
    const layer = canvas.getCurrentDrawing().getCurrentLayer();
    const selectedList = canvas.getSelectedElems();
    const elemList = layer.childNodes;

    for (var i = 0; i < elemList.length; i++) {
      if (elemList[i].tagName == 'title') continue;
      let k = 0;

      for (let j = 0, len = selectedList.length; j < len; j++) {
        if (!selectedList[j]) continue;
        if (selectedList[j].id != elemList[i].id) k++;
        if (k == len) {
          var bbox;
          if ($(elemList[i]).hasClass('layoutBox')) {
            bbox = canvas.runExtensions('getLayoutBoxCoord', {
              layoutBox: elemList[i]
            });
          } else {
            bbox = canvas.getBBox(elemList[i]);
          }

          if (!bbox || isNaN(bbox.x) || isNaN(bbox.y) || isNaN(bbox.width) || isNaN(bbox.height)) {
            continue;
          }
          const inx = objectCoord.push(bbox);

          objectCoord[inx - 1].rotate = canvas.getRotationAngle(elemList[i]);
          objectCoord[inx - 1].id = elemList[i].getAttribute('id');
          // drawObjectsGuideLine(objectCoord[inx-1]);
        }
      }
    }

    // root element
    const contentElement = $('#canvasBackground').get(0);
    const obj = canvas.getBBox(contentElement);
    obj.id = contentElement.getAttribute('id');
    obj.rotate = 0;
    // drawObjectsGuideLine(obj);

    let coord = INKIVE.Helpers.getObjectCoordinates(canvas, obj);

    objectsGuidelines = {
      vertical: objectCoordinatesHelper.getYCoordinates(coord),
      horizontal: objectCoordinatesHelper.getXCoordinates(coord),
      objects: [obj].concat(objectCoord)
    };

    for (var i = 0; objectCoord && i < objectCoord.length; i++) {
      if (!objectCoord[i]) {
        continue;
      }

      coord = INKIVE.Helpers.getObjectCoordinates(canvas, objectCoord[i]);

      objectsGuidelines.vertical = objectsGuidelines.vertical.concat(
        objectCoordinatesHelper.getYCoordinates(coord)
      );

      objectsGuidelines.horizontal = objectsGuidelines.horizontal.concat(
        objectCoordinatesHelper.getXCoordinates(coord)
      );
    }
  }

  function resetObjectGuideLine (direction) {
    if (direction) {
      $('.guideLineGroup .' + direction).remove();
    } else {
      $('.guideLineGroup').remove();
    }
  }

  /**
   * dx, dy - for direction. dx > 0 - right, dx < 0 - left, dy > 0 - bottom, dy < 0 - top
   */
  function snapObject (selectedObject, dx, dy) {
    if (!isEnabled) return;

    const coord = INKIVE.Helpers.getObjectCoordinatesByDirection(canvas, selectedObject, dx - lastDx >= 0, dy - lastDy >= 0);
    const coordObject = {
      vertical: objectCoordinatesHelper.getYCoordinates(coord),
      horizontal: objectCoordinatesHelper.getXCoordinates(coord)
    };

    dx && orthogonalSnap('horizontal');
    dy && orthogonalSnap('vertical');

    function orthogonalSnap (direction) {
      let isBreak = false;
      const xComponent = direction === 'horizontal' ? 1 : 0;
      const yComponent = 1 - xComponent;

      if (objectsGuidelines) {
        for (let i = 0; i < objectsGuidelines[direction].length && !isBreak; i++) {
          const pointTo = objectsGuidelines[direction][i];

          for (let j = 0; j < coordObject[direction].length && !isBreak; j++) {
            const pointFrom = coordObject[direction][j];
            const delta = pointTo - pointFrom;

            if (Math.abs(delta) < snapDistance) {
              canvas.softMoveSelectedElements(delta * xComponent, delta * yComponent);
              resetObjectGuideLine(direction);
              drawLine(direction, pointTo);
              isBreak = true;
            }
          }
        }

        if (!isBreak) {
          resetObjectGuideLine(direction);
        }
      }
    }

    lastDx = dx;
    lastDy = dy;
  }

  function drawLine (direction, coord) {
    const width = $('#svgroot').width();
    const height = $('#svgroot').height();

    const guideLineGroup = $('.guideLineGroup').length
      ? $('.guideLineGroup').get(0)
      : addSvgElementFromJson({
        element: 'g',
        curStyles: false,
        attr: {
          id: getNextId(),
          class: 'guideLineGroup',
          style: 'pointer-events:none'
        }
      }, $('#svgpanel').get(0));

    const line = addSvgElementFromJson({
      element: 'line',
      attr: {
        x1: direction === 'horizontal' ? coord : 0,
        y1: direction === 'horizontal' ? 0 : coord,
        x2: direction === 'horizontal' ? coord : width,
        y2: direction === 'horizontal' ? height : coord,
        stroke: '#0000FF',
        'stroke-width': '1',
        'pointer-events': 'none',
        class: direction,
        'stroke-opacity': '0.9',
        'stroke-dasharray': '1 1'
      }
    }, guideLineGroup);
  }

  return {

    // The main (left) mouse button is held down on the canvas area
    mouseDown: function () {
      if (!isEnabled || curConfig.gridSnapping) {
        return;
      }

      lastDx = 0;
      lastDy = 0;

      (canvas.getMode() == 'select') && initObjectCoordInfo();
    },

    mouseUp: function () {
      if (!isEnabled || curConfig.gridSnapping) {
        return;
      }

      resetObjectGuideLine();
    },

    // The mouse is moved on the canvas area
    mouseMove: function (opts) {
      if (!isEnabled || curConfig.gridSnapping) {
        return;
      }

      if (canvas.getMode() === 'select') {
        const selected = canvas.getSelectedElems();

        if (selected.length > 1) return;

        for (let i = 0; i < selected.length; i++) {
          if (!selected[i]) continue;

          const obj = selected[i].getAttribute('class') !== 'layoutBox'
            ? canvas.getBBox(selected[i])
            : canvas.runExtensions('getLayoutBoxCoord', {
              layoutBox: selected[i]
            });

          obj.x = obj.x + (opts.dx);
          obj.y = obj.y + (opts.dy);

          obj.rotate = canvas.getRotationAngle(selected[i]);
          obj.id = selected[i].getAttribute('id');
          obj.rotate || snapObject(obj, opts.dx, opts.dy);
        }
      }
    },

    // The zoom level is changed
    zoomChanged: function () {
      if (!isEnabled || curConfig.gridSnapping) {
        return;
      }

      // Just reset all
      resetObjectGuideLine();
    },

    enableSnap: function () {
      isEnabled = true;//! INKIVE.C.IS_MOBILE;
    },

    disableSnap: function () {
      isEnabled = false;
    }
  };
};
